import { Role, User } from "../../auth/types/interfaces";
import { forbiddenResponse, successResponse } from "../constants";

export const loader = async (user: User) => {
  /**
   * Loader function for Cargo pages.
   *
   * @returns {Promise<Response>} A Promise that resolves with a Response object.
   *   Returns OK if user has Cargo role or Admin role
   *   Returns 403 Forbidden valid role is not found
   */
  if (
    user.roles.includes(Role.CARGO_CLAIM_USER) ||
    user.roles.includes(Role.WC_CLAIM_PRODUCT_GROUP)
  ) {
    return successResponse();
  } else {
    throw forbiddenResponse();
  }
};
